var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from "@tanstack/react-query";
import { array, constant, exact, nonEmptyString, nullable, optional, } from "decoders";
import { EXTENSION_ID } from "~/client/constants";
import sleep from "~/shared/utils/sleep";
const recipeDataResponseMessageDecoder = exact({
    type: constant("RECIPE_DATA"),
    sender: constant("service-worker"),
    payload: exact({
        recipe: exact({
            attribution: nullable(nonEmptyString),
            imageUrl: nullable(nonEmptyString),
            ingredientGroups: array(exact({
                name: optional(nonEmptyString),
                ingredients: array(nonEmptyString),
            })),
            time: nullable(nonEmptyString),
            title: nonEmptyString,
            url: nonEmptyString,
            yield: nullable(nonEmptyString),
        }),
    }),
});
const timeout = (ms) => __awaiter(void 0, void 0, void 0, function* () {
    yield sleep(ms);
    throw new Error("Request timed out.");
});
const useImportRecipeFromExtension = ({ enabled, } = {}) => useQuery({
    enabled,
    queryKey: ["import-recipe"],
    queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!((_a = window.chrome) === null || _a === void 0 ? void 0 : _a.runtime)) {
            throw new Error("Extension helpers do not exist.");
        }
        const response = yield Promise.race([
            window.chrome.runtime.sendMessage(EXTENSION_ID, {
                type: "RECIPE_IMPORTER_READY",
                sender: "web-app",
            }),
            timeout(10000),
        ]);
        const decodedResponse = recipeDataResponseMessageDecoder.verify(response);
        return decodedResponse;
    }),
});
export default useImportRecipeFromExtension;
